import { fromJS } from 'immutable';

export default fromJS({
    isForgotPasswordPopupOpen: false,
    isForgotPasswordResultPopupOpen: false,
    username: null
});